import { useReducer, useCallback } from 'react'
import { createEmptyBookingDraft } from '../../../domain/models/nonna'

const makeInitialState = () => ({
  draft: createEmptyBookingDraft(),
  submissionStatus: 'idle',
  confirmedBooking: null,
  error: null,
})

function reducer(state, action) {
  switch (action.type) {
    case 'SET_PARENT_INFO':
      return { ...state, draft: { ...state.draft, parentInfo: action.payload } }
    case 'SET_CHILDREN':
      return { ...state, draft: { ...state.draft, children: action.payload } }
    case 'SET_SCHEDULE':
      return { ...state, draft: { ...state.draft, schedule: action.payload } }
    case 'SET_NONNA':
      return { ...state, draft: { ...state.draft, selectedNonna: action.payload } }
    case 'RESET':
      return makeInitialState()
    case '_SUBMIT_START':
      return { ...state, submissionStatus: 'submitting', error: null }
    case '_SUBMIT_SUCCESS':
      return { ...state, submissionStatus: 'confirmed', confirmedBooking: action.payload }
    case '_SUBMIT_FAIL':
      return { ...state, submissionStatus: 'failed', error: action.payload }
    default:
      return state
  }
}

export function useBookingViewModel() {
  const [state, dispatch] = useReducer(reducer, undefined, makeInitialState)

  const setParentInfo = useCallback((info) => {
    dispatch({ type: 'SET_PARENT_INFO', payload: info })
  }, [])

  const setChildren = useCallback((arr) => {
    dispatch({ type: 'SET_CHILDREN', payload: arr })
  }, [])

  const setSchedule = useCallback((sched) => {
    dispatch({ type: 'SET_SCHEDULE', payload: sched })
  }, [])

  const setNonna = useCallback((nonna) => {
    dispatch({ type: 'SET_NONNA', payload: nonna })
  }, [])

  const reset = useCallback(() => {
    dispatch({ type: 'RESET' })
  }, [])

  const confirm = useCallback(
    async (repository, parentId) => {
      dispatch({ type: '_SUBMIT_START' })
      try {
        const booking = await repository.createBooking(state.draft, parentId)
        dispatch({ type: '_SUBMIT_SUCCESS', payload: booking })
        return booking
      } catch (err) {
        dispatch({
          type: '_SUBMIT_FAIL',
          payload: err.message || 'Something went wrong. Please try again.',
        })
        return null
      }
    },
    [state.draft],
  )

  return {
    draft: state.draft,
    submissionStatus: state.submissionStatus,
    confirmedBooking: state.confirmedBooking,
    error: state.error,
    setParentInfo,
    setChildren,
    setSchedule,
    setNonna,
    reset,
    confirm,
  }
}
